import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Seo } from "@/components/Seo";
import { COMPANY, LICENSE_LINE } from "@/lib/company";

export const STATUTORY_NOTICE =
  `Statutory notice: ${COMPANY.legalName} is a real-estate brokerage operating in Dubai under the regulation of the Real Estate Regulatory Agency (RERA) and the Dubai Land Department (DLD). All prices, availability, payment plans, yields and project details shown on this website are indicative, provided for general guidance, and may change without notice. Off-plan payments must only be made into project escrow accounts approved by the Dubai Land Department (Law No. 8 of 2007 concerning Escrow Accounts for Real Estate Development). Always verify broker cards and advertising permits (Trakheesi) on the Dubai REST app before paying any funds. Nothing on this website constitutes legal, tax, investment or financial advice.` +
  (LICENSE_LINE ? ` ${LICENSE_LINE}.` : "");

export default function LegalPage({ title, updated, intro, sections, path, description }) {
  return (
    <main className="bg-ink min-h-screen" data-testid={`legal-${path.replace("/", "")}-page`}>
      <Seo title={`${title} — Haven & Hill Properties`} description={description} path={path} />
      <Navbar />
      <div className="pt-36 pb-20 max-w-3xl mx-auto px-4 sm:px-6">
        <p className="text-xs uppercase tracking-[0.35em] text-gold-light/90 font-medium mb-5">Legal</p>
        <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#F8F6F0] leading-tight">{title}</h1>
        <p className="mt-3 text-xs text-zinc-500">Last updated: {updated}</p>
        {intro && <p className="mt-6 text-sm sm:text-base text-zinc-300 leading-relaxed">{intro}</p>}

        <div className="mt-8 rounded-2xl border border-gold/25 bg-gold/[0.05] p-6" data-testid="statutory-warning">
          <p className="text-xs uppercase tracking-[0.25em] text-gold-light font-medium mb-3">Statutory warning</p>
          <p className="text-xs sm:text-sm text-zinc-300 leading-relaxed">{STATUTORY_NOTICE}</p>
        </div>

        <div className="mt-10 space-y-9">
          {sections.map((s, i) => (
            <section key={s.h}>
              <h2 className="font-serif text-xl text-gold-pale">
                <span className="text-gold/50 text-sm mr-2">{String(i + 1).padStart(2, "0")}</span>
                {s.h}
              </h2>
              <div className="mt-3 space-y-3">
                {s.body.map((p, j) => (
                  <p key={j} className="text-sm text-zinc-300 leading-relaxed">{p}</p>
                ))}
              </div>
            </section>
          ))}
        </div>

        <p className="mt-12 text-xs text-zinc-600 leading-relaxed">
          Questions about this document? Write to support@havenandhillproperties.com.
        </p>
      </div>
      <Footer />
    </main>
  );
}
